import { render, staticRenderFns } from "./JiCardList.vue?vue&type=template&id=6ab1710a&scoped=true"
import script from "./JiCardList.vue?vue&type=script&lang=js"
export * from "./JiCardList.vue?vue&type=script&lang=js"
import style0 from "./JiCardList.vue?vue&type=style&index=0&id=6ab1710a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab1710a",
  null
  
)

export default component.exports